import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { computed } from '@ember/object';

export enum PlanType {
  Essentials = 'essentials',
  Basic = 'basic',
  Premium = 'premium',
  Enterprise = 'enterprise',
  Startup = 'startup',
  CdpStarter = 'cdp starter',
  CdpPremium = 'cdp premium',
  NotReportable = 'not reportable',
}

export const PIPELINES_ONLY_PLAN_TYPES = [PlanType.CdpStarter, PlanType.CdpPremium];

export default class PlanModel extends Model {
  @attr('string') name!: string;
  @attr('string') slug!: string;
  @attr('number') price!: number;
  @attr('number') cdpPremiumPrice!: number;
  @attr('number') cdpApiCalls!: number;
  @attr('number') annualPrice!: number;
  @attr('number') customers!: number;
  @attr('boolean') multiSmtp!: boolean;
  @attr('number') emailsSent!: number;
  @attr('string') meteredCustomerRate!: string;
  @attr('boolean') premium!: boolean;
  @attr('boolean') legacy!: boolean;
  @attr('boolean') disabled!: boolean;
  @attr('boolean') hidden!: boolean;
  @attr('boolean') annual!: boolean;
  @attr('boolean') plannedCustomSmtp!: boolean;
  @attr('string') intervalName!: string;
  @attr('string') planType!: PlanType;
  @attr('number') objects!: number;
  @attr('string') meteredObjectRate!: string;
  @attr('string') displayName!: string;

  @computed('annualPrice')
  get monthlyPriceIfPaidAnnually(): null | number {
    return this.annualPrice && this.annualPrice / 12;
  }

  @computed('intervalName')
  get intervalNameForDisplay(): string {
    switch (this.intervalName) {
      case 'month':
        return 'monthly';
      case 'quarter':
        return 'quarterly';
      case 'biannual':
        return 'semi-annual';
      case 'year':
        return 'annual';
    }
    return 'custom';
  }

  @computed('intervalName')
  get intervalNameForCurrentPlan(): string {
    return this.intervalName === 'biannual' ? 'six months' : this.intervalName;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    plan: PlanModel;
  }
}
